<template>
  <div id="wt-system-menu-container">
    <div id="wt-system-menu">
      <div>
        <a @click.prevent="setSystem('Streamline')" class="wt-system-menu-item">
          <div class="wt-img-container">
            <img src="@/assets/img/icons/streamline.png" alt="streamline logo" />
          </div>
          <div class="system-name system-name-black">
            <p>Streamline</p>
          </div>
          <i class="fas fa-chevron-right left-arrow"></i>
        </a>

        <a @click.prevent="setSystem('BPM')" class="wt-system-menu-item">
          <div class="wt-img-container">
            <img src="@/assets/img/icons/bpm.png" alt="streamline logo" />
          </div>
          <div class="system-name system-name-black">
            <p>BPM</p>
          </div>
          <i class="fas fa-chevron-right left-arrow"></i>
        </a>
        <p class="caption">Select a system</p>
      </div>

      <img
        src="@/assets/default/Business_SVG.svg"
        alt="Isometric Business Logo"
        class="wt-isometric"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SystemMenuContainer",
  computed: {},
  components: {},


  data: function() {
    return {};
  },
  methods: {
    setSystem(systemName) {
      this.$store.commit("setTypeLayout", 2);
      this.$store.commit("setActiveSystem", systemName);
      if (systemName == "Streamline") this.$router.push({ name: "home" });
      if (systemName == "BPM") this.$router.push({ name: "bpm_home" });
    }
  },
  watch: {},
  created() {
    this.$store.commit("setTypeLayout", 2);
    this.$store.commit("setActiveSystem", "");
  }
};
</script>

<style>
</style>
